module.exports = __webpack_public_path__ + "img/instagram.5f5e8364.svg";